import { gql } from '@grandvisionhq/graphql';

const GET_TOPIC_LIST = gql`
  query GetTopicList {
    getTopicList {
      key
      label
    }
  }
`;

export { GET_TOPIC_LIST };
//# sourceMappingURL=get-topic-list.js.map
